import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRefreshTokenRequest } from '../api/api';
import Footer from '../components/Footer';
import KnowledgeTestModal from '../components/modal/KnowledgeTestModal';
import TimeOutModal from '../components/modal/TimeOutModal';
import { useKnowledgeTestDispatch, useKnowledgeTestState } from '../contexts/KnowledgeTestContext';
import { useUrl } from '../contexts/LanguageContext';
import ROUTE_NAME from '../routes/RouteName';
import { aesDecrypt } from './crypto';

export function ProtectedRoute({ children }) {
    const navigate = useNavigate();
    const location = useLocation();

    const { updateUrl } = useUrl();

    const knowledgeTestDispatch = useKnowledgeTestDispatch();
    const knowledgeTestState = useKnowledgeTestState();

    const [cached, setCached] = useState(false);
    const [isRenderKnowledgeTestModal, setIsRenderKnowledgeTestModal] = useState(false);
    const [isTimeOutModalOpen, setIsTimeOutModalOpen] = useState(false);
    const timeout = 1000 * 60 * 30;

    const handleOnIdle = () => {
        sessionStorage.clear();
        setIsTimeOutModalOpen(true);
    };

    useIdleTimer({
        timeout,
        onIdle: handleOnIdle,
        onActive: () => null,
        onAction: () => null,
        disabled: !cached,
        debounce: 250,
    });

    useEffect(() => {
        updateUrl(location.pathname);

        if (!cached) {
            switch (location.pathname) {
                case ROUTE_NAME.HOME:
                case ROUTE_NAME.TWO_FACTOR_AUTH:
                case ROUTE_NAME.REGISTRATION:
                case ROUTE_NAME.REGISTRATION_DETAILS:
                case ROUTE_NAME.REGISTRATION_COMPLETED:
                case ROUTE_NAME.FIRST_TIME_DASHBOARD:
                    // case ROUTE_NAME.FORGOT_PASSWORD:
                    // case ROUTE_NAME.EMAIL_ACTIVATION:
                    // case ROUTE_NAME.RESET_PASSWORD:
                    break;
                default:
                    setCached(true);
            }
        }

        switch(location.pathname) {
            case ROUTE_NAME.INVEST_NOW:
            case ROUTE_NAME.PROFILE:
                setIsRenderKnowledgeTestModal(true);
                break;
            default:
                setIsRenderKnowledgeTestModal(false);
        }
    }, [location, cached]);

    useEffect(() => {
        const tokenType = sessionStorage.getItem('token_type');
        const accessToken = aesDecrypt(sessionStorage.getItem('access_token'));

        if (tokenType === null || tokenType === 'undefined' || accessToken === null || accessToken === 'undefined') {
            navigate(ROUTE_NAME.HOME);
        }
    }, [navigate]);

    const EXPIRATION_DURATION = 50 * 60 * 1000;

    const [key, setKey] = useState(0);

    useEffect(() => {
        const expirationTime = localStorage.getItem('expiration_time');

        let delay;
        if (expirationTime) {
            const remainingTime = new Date(expirationTime).getTime() - new Date().getTime();
            delay = remainingTime > 0 ? remainingTime : 0;

            setTimeout(() => {
                getRefreshTokenRequest();

                const newExpirationTime = new Date(new Date().getTime() + EXPIRATION_DURATION);
                localStorage.setItem('expiration_time', newExpirationTime);

                setKey(prevKey => prevKey + 1);
            }, delay);

            if (delay <= 0) {
                const newExpirationTime = new Date(new Date().getTime() + EXPIRATION_DURATION);
                localStorage.setItem('expiration_time', newExpirationTime);
            } 
        } else {
            const newExpirationTime = new Date(new Date().getTime() + EXPIRATION_DURATION);
            localStorage.setItem('expiration_time', newExpirationTime);

            delay = EXPIRATION_DURATION;

            setTimeout(() => {
                getRefreshTokenRequest();
                setKey(prevKey => prevKey + 1);
            }, delay);
        }
    }, [key]);

    return (
        <div className="theme-light">
            <div className="wrapper">
                <TimeOutModal isOpen={isTimeOutModalOpen} />
                {
                    isRenderKnowledgeTestModal &&
                    <KnowledgeTestModal />
                }
                {children}
                <Footer />
            </div>
        </div>
    );
};
